import React, { Component } from 'react'
import { Button, Modal } from 'semantic-ui-react'

class Confirm extends Component {
  constructor() {
    super();
    this.state = {
    }
  }


  render() {

    let { statementNumber, handleAuthorize, numberOfShipments, amountToAuthorize, close, tempPunNumber, tempPortCode, tempBusinessName, tempPunInfo, isACHCredit, responseReceived, errorCode, errorMsg } = this.props

    let label = "";
    if (tempPunInfo === "BROKER_PUN")
      label = "Broker";
    else if (tempPunInfo === "CUSTOMER_PUN")
      label = "Customer";

    return (
      <div>
        <Modal dimmer='inverted' className='confirmAuthorize' size='mini' open={true}>
          <Modal.Header>Authorize Statement #{statementNumber}</Modal.Header>
          {
            (errorCode == 401 && errorMsg) ? <Modal.Content><p style={{ color: "red" }}>{errorMsg}</p></Modal.Content> :
              <Modal.Content>
                Are you sure you want to authorize <strong>{numberOfShipments}</strong> shipment{numberOfShipments == 1 ? '' : 's'} for <strong>${amountToAuthorize}</strong> associated with the following details?<br /> <br />
                {label} Business Name: {tempBusinessName} <br />
                {!isACHCredit && <>
                  {label} PUN: {tempPunNumber}
                  <br />
                  <br />
                  {(responseReceived && !tempPunNumber) && <p style={{ color: "red" }}>No PUN is setup</p>}
                </>
                }
                {isACHCredit && <p> This user is ACH Credit Payer</p>}
              </Modal.Content>
          }
          <Modal.Actions>
            <Button className='dontAuthorizeBtn' onClick={() => close()}>No</Button>
            <Button
              className='confirmAuthorizeBtn'
              onClick={() => handleAuthorize()}
              content='Yes'
              disabled={(responseReceived && !tempPunNumber) && !isACHCredit}
            />
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

export default Confirm